import { values } from 'lodash';

import { SchemaField } from '../../../../../objects/generic/serialization/schema-field';
import { CommunicationsResponseSchema } from '../../generic/communications-response/communications-response-schema';

import { CommunicationsResponseConferenceParticipantCreateError } from './communications-response-conference-participant-create-error';

export class CommunicationsResponseConferenceParticipantCreateSchema extends CommunicationsResponseSchema {
  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Schema Definition
  ////////////////////////////////////////////////////////////////////////////////////////////////

  /**
   * Schema for this object is encoded into a command name, and in parameters
   */
  public getSchemaDefinition(): { [key: string]: import('joi').AnySchema } {
    const parameters = super.getSchemaDefinition();

    /* eslint-disable */
    parameters[CommunicationsResponseConferenceParticipantCreateSchema.error] = SchemaField.string(
      CommunicationsResponseSchema.Defaults.error,
    )
      .optional()
      .valid(...values(CommunicationsResponseConferenceParticipantCreateError));
    /* eslint-enable */

    return parameters;
  }
}
